import AppButton from "../../../../shared/oversight-core/ui-elements/buttons/app-button/app-button";
import styles from "./add-access-button.module.scss";

interface IProps {
  onClick: () => void;
}

const AddAccessButton = (props: IProps) => (
  <div>
    <AppButton
      text="Add access"
      iconName="add"
      variant="transparentWithBorder"
      size="small"
      className={`${styles.addAccessButton} px-3`}
      onClick={props.onClick}
    />
  </div>
);

export default AddAccessButton;
